var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamousRelativesAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1429,
    height: 2151,
    viewBox: "0 0 1429 2151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2505.46 1169.78L1648.65 1042.24L2442.88 850.783L2379.98 698.613L1539.44 907.223L2199.42 427.638L2082.69 311.017L1386.42 824.59L1812 129.224L1659.29 66.5476L1213.05 806.504L1339.16 2H1173.93L1045.94 855.772L853.803 64.3646L701.091 127.041L910.446 964.598L429.154 306.651L312.118 423.273L827.518 1117.08L129.675 693L66.7755 845.17L809.369 1289.83L2 1164.17V1328.81L858.811 1456.34L64.5866 1647.8L127.486 1799.97L968.024 1591.36L307.736 2070.95L424.773 2187.57L1121.05 1674L695.461 2369.36L848.172 2432.04L1294.42 1692.08L1168.3 2496.59H1333.53L1461.52 1642.81L1653.66 2434.22L1806.37 2371.54L1597.02 1533.99L2078.31 2191.93L2195.35 2075.31L1679.95 1381.51L2377.79 1805.59L2440.69 1653.42L1698.1 1208.76L2505.46 1334.42V1169.78Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamousRelativesAttract);
export default __webpack_public_path__ + "static/media/famous-relatives-attract.5671eca94db12564e850c5157c846043.svg";
export { ForwardRef as ReactComponent };